module.exports = "<div class=\"container\">\n  <p>HoRIzON - driving Human Robot InteractiONs |\n    <a style=\"color: #05BDFF\" href=\"https://www.isae-supaero.fr/fr/isae-supaero/mecenat-relations-avec-la-fondation-isae-supaero/chaire-dassault-aviation/\">Dassault Aviation chair - ISAE-SUPAERO</a>\n  </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/footer.html
// module id = 18
// module chunks = 0